import UndoStack from './undoStack';

export default new UndoStack();
